<template lang="pug">
span.x-action-bar-ex-pin
  v-tooltip(
    v-if="!isHidden"
    bottom
  )
    template(#activator="{ on, attrs }")
      v-btn.mr-0.x-invisible(
        v-if="isInvisible"
        v-bind="attrs"
        v-on="on"
        disabled
        :text="hasText"
        :icon="!hasText"
        :class="clazz"
        :small="small"
        :x-small="xSmall"
      )
        v-icon(v-show="hasIcon" :left="hasText")

        div(
          v-if="hasText"
          :style="style"
        )
          | {{ verb }}

      v-btn.mr-0(
        v-else
        v-bind="attrs"
        v-on="on"
        :ripple="isClickable"
        :disabled="isDisabled"
        :text="hasText"
        :icon="!hasText"
        :small="small"
        :x-small="xSmall"
        :color="color"
        :class="clazz"
        @click="if (isClickable) { $emit('perform', { link }) }"
      )
        v-icon(
          v-show="hasIcon"
          :left="hasText"
          :color="color"
        )
          | {{ icon }}

        div(
          v-if="hasText"
          :style="style"
        )
          | {{ verb }}

    span(
      :class="tooltip.clazz",
      :color="tooltip.color",
      :style="tooltip.style"
    )
      span.text-md.font-weight-medium(v-show="tooltip.title") {{ tooltip.title }}
      br(v-show="tooltip.title && tooltip.description")
      span.font-weight-light(v-show="tooltip.description") {{ tooltip.description }}
</template>

<style lang="scss">
.x-action-bar-ex-pin {
  .x-non-clickable,
  .x-non-clickable *,
  .x-non-clickable:hover * {
    // pointer-events: none !important;
    cursor: default !important;
    background-color: transparent !important;
    box-shadow: none !important;
  }
}
</style>

<script>
import { hasRel } from '@/helpers/rels'
import { selectState, selectOptions, selectClass, selectColor, selectFont } from '@/helpers/styles'
import { parseEref } from '@/helpers/erefs'

export default {
  props: {
    entity: Object,
    data: Object,
    row: Object,

    action: Object,
    noMargin: Boolean,
    small: Boolean,
    xSmall: Boolean,
  },

  computed: {
    pin() {
      const { entity: page, data, row } = this
      return selectState(this.link.states, { page, data, row }) || {}
    },

    link() {
      return this.action || {}
    },

    context() {
      const { site, eref } = this.$route.params;
      return {
        site: site,
        eref: parseEref(eref),
        page: this.entity,
        data: this.data,
        row: this.row
      }
    },

    options() {
      const { link, pin, context } = this
      const options = selectOptions([link, pin], context) || {}
      return options
    },

    hasText() {
      return !this.icon || hasRel(this.pin, 'Text') || hasRel(this.link, 'Text')
    },

    hasIcon() {
      return this.icon
    },

    isClickable() {
      return !!(this.link.eref || this.link.href || !hasRel(this.link, 'State'))
    },

    isDisabled() {
      return this.options.disabled
    },

    isHidden() {
      return this.options.hidden
    },

    isInvisible() {
      return this.options.invisible
    },

    verb() {
      return this.link.verb || this.link.title || this.link.name || this.link.eref
    },

    title() {
      return this.link.title || this.link.verb || this.link.name || this.link.eref
    },

    description() {
      return this.link.description
    },

    icon() {
      return this.options.icon
    },

    color() {
      return selectColor(this.options.style || this.options.color)
    },

    clazz() {
      let clazz = selectClass(this.options.style || this.options.color)
      if (!this.isClickable) {
        clazz = `${clazz} x-non-clickable`
      }
      return clazz
    },

    style() {
      return selectFont(this.options.font)
    },

    tooltip() {
      const { title, description, link, pin } = this
      const current = { title, description }
      const pinned = { title: pin.title, description: pin.description }

      const { entity: page, data, row } = this
      const options = selectOptions([current, link.tooltip, pinned, pin.tooltip], { page, data, row })

      return {
        title: options.title,
        description: options.description,
        color: selectColor(options.style || options.color),
        clazz: selectClass(options.style || options.color),
        style: selectFont(options.font)
      }
    },
  },
}
</script>